export default __webpack_public_path__ + "static/media/F.05e0e486.svg";